module.exports = __webpack_public_path__ + "27870dd0099c4c450c0f2fddcdd4bd7b.pdf";